import React from 'react';
import { about5, heroVideo, arashBg, aboutBg, contactBg } from '../../assets/images';
import Header from '../../Components/Header/Header';
import OtherHero from '../../Components/Breadcrumb/OtherHero/OtherHero';
import ContactItems from './ContactItems/ContactItems';

const Contact = () => {
  return (
    <>
      <div
        className='bg-black/60'
        style={{
          position: 'relative',
          overflow: 'hidden',
          backgroundImage: `url(${contactBg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          width: '100%',
          height: window.innerWidth < 640 ? '250px' : '300px',
        }}
      >
        <Header />
        <OtherHero title="Əlaqə"/>

      </div>

      <ContactItems/>
    </>
  );
};

export default Contact;
